import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import styles from "../../constants/assets/variables";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import AddressButtonSecondary from "sushiweb/Order/AddressButtonSecondary";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import QcDriverBasicDetails from "../../components/QcDetails/QcDriverBasicDetails";
import QcDriverDocumentDetails from "../../components/QcDetails/QcDriverDocumentDetails";
import QcDriverBasicDetailsEdit from "../../components/QcDetails/QcDriverBasicDetailsEdit";
import QcDriverDocumentDetailsEdit from "../../components/QcDetails/QcDriverDocumentDetailsEdit";
import {
  approveQcDetails,
  getQcDetails,
  getQcAdditionalData,
  resetState,
  saveQcDetails,
  setQcDetails,
} from "../../store/actions/QcDetails";
import {
  capitalizeFirstLetter,
  debounce,
  getPath,
  isEmpty,
  isMobile,
  isValNull,
} from "../../utils";
import BlankState from "../../components/Common/BlankState";
import variables from "../../constants/assets/variables";
import {
  shouldQcApproved,
  handleQcValidations,
} from "../../components/QcDetails/HelperFunctions";
import ConfirmationModal from "../../components/Common/ConfirmationModal";
import ErrorModal from "../../components/Common/ErrorModal";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import Permission from "../../components/Common/Permission";
import { useParams } from "react-router-dom";

const detailTabs = ["Details", "Documents"];

var interval = null;

const QcDetails2 = ({
  getQcDetails,
  getQcAdditionalData,
  approveQcDetails,
  saveQcDetails,
  qcDetails,
  currentActiveFeId,
  qcRejectionReasons,
  qcDocTypes,
  setQcDetails,
  resetState,
}) => {
  const history = useHistory();
  const { Feid } = useParams();
  const [activeIndex, setActiveIndex] = useState("Details");
  const [saveState, setSaveState] = useState(false);
  const [currentFeId, setCurrentFeId] = useState("");
  const [editableField, setEditableField] = useState("");
  const [showSingleFieldEditOptions, setShowSingleFieldEditOptions] =
    useState("");
  const [initialState, setInitialState] = useState({});
  const [showQcButton, setShowQcButton] = useState(false);
  const [qcApproved, setQcApproved] = useState(false);
  const [qcPartiallyApproved, setQcPartiallyApproved] = useState(false);
  const [showQcApproveModal, setShowQcApproveModal] = useState(false);
  const [errors, setErrors] = useState([]);
  const allActions = MenuActionsMappings[MenuNames.QUALITY_CHECK];
  const onboardingFlow = getPath(qcDetails, "onboarding_flow", "");
  const editStateError = `${capitalizeFirstLetter(
    editableField.split("_").join(" ")
  )} field is in edit state, please save or cancel changes before moving forward`;

  const handleTabClick = (val) => {
    setActiveIndex(val);
  };

  const handleVerifyClick = () => {
    setSaveState(true);
  };

  const isVerifyDIsabled = () => {
    let selfieNotUploaded =
      isValNull(qcDetails.basic_details.driver_photo) ||
      isValNull(qcDetails.basic_details.driver_photo.url);
    if (selfieNotUploaded) {
      return selfieNotUploaded;
    }
    if (qcDetails.qc_status == "PARTIALLY_APPROVED") {
      if (onboardingFlow == "FASTRACK") {
        return (
          isValNull(qcDetails.document_details.pan_card_doc) ||
          isValNull(qcDetails.document_details.pan_card_doc.value) ||
          isValNull(qcDetails.document_details.bank_doc) ||
          isValNull(qcDetails.document_details.bank_doc.value)
        );
      } else {
        return (
          isValNull(qcDetails.document_details.bank_doc) ||
          isValNull(qcDetails.document_details.bank_doc.value)
        );
      }
    }
    return false;
  };

  const handleCancelClick = () => {
    setSaveState(false);
    setEditableField("");
    setShowSingleFieldEditOptions("");
    const payload = {
      basic_details: qcDetails.basic_details
        ? JSON.parse(JSON.stringify(qcDetails.basic_details))
        : {},
      document_details: qcDetails.document_details
        ? JSON.parse(JSON.stringify(qcDetails.document_details))
        : {},
    };
    if (!qcApproved) {
      setInitialState(payload);
    }
    if (!qcApproved && shouldQcApproved(payload)) {
      setShowQcButton(true);
    } else {
      setShowQcButton(false);
    }
  };

  const handleSaveClick = () => {
    if (editableField !== "") {
      setErrors([editStateError]);
      return;
    }
    // const payload = {
    //   basic_details: qcDetails.basic_details,
    //   document_details: qcDetails.document_details,
    // };
    const validationErrors = handleQcValidations(initialState, qcDetails);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }
    saveQcDetails(currentActiveFeId, initialState).then((res) => {
      if (res) {
        setEditableField("");
        setShowSingleFieldEditOptions("");
        getQcDetails(currentActiveFeId);
        // const newDetails = JSON.parse(JSON.stringify(qcDetails));
        // newDetails["basic_details"] = initialState.basic_details;
        // newDetails["document_details"] = initialState.document_details;
        // setQcDetails(newDetails);
      }
    });
  };

  const handleVerifiedChange = (item, val, inKey) => {
    const values = { ...initialState };
    val = val === "true" ? true : false;
    if (val) {
      values[inKey][item.key]["rejection_reason"] = "";
    }
    values[inKey][item.key]["verified"] = val;
    if (!qcApproved && shouldQcApproved(values)) {
      setShowQcButton(true);
    } else {
      setShowQcButton(false);
    }
    setInitialState(values);
  };

  const handleRejectionReasonChange = (keyToChange, val, extraParams) => {
    const item = extraParams[0];
    const inKey = extraParams[1];
    const values = { ...initialState };
    values[inKey][item.key]["rejection_reason"] = val;
    setInitialState(values);
  };

  const handleDocTypeChange = (keyToChange, val, extraParams) => {
    const item = extraParams[0];
    const inKey = extraParams[1];
    const values = { ...initialState };
    values[inKey][item.key]["doc_type"] = val;
    setInitialState(values);
  };

  const handleQcApprove = () => {
    // const payload = {
    //   basic_details: qcDetails.basic_details,
    //   document_details: qcDetails.document_details,
    // };
    // const validationErrors = handleQcValidations(payload);
    const validationErrors = handleQcValidations(initialState, qcDetails);
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      setShowQcApproveModal(false);
      return;
    }
    saveQcDetails(currentActiveFeId, initialState).then((res) => {
      if (res) {
        setEditableField("");
        setShowSingleFieldEditOptions("");
        // const newDetails = JSON.parse(JSON.stringify(qcDetails));
        // newDetails["basic_details"] = initialState.basic_details;
        // newDetails["document_details"] = initialState.document_details;
        let aprovePayload = { qc_status: "APPROVED" };
        if (!["PARTIALLY_APPROVED", "REJECTED"].includes(qcDetails.qc_status)) {
          aprovePayload = { qc_status: "PARTIALLY_APPROVED" };
        }
        if (qcDetails.blinkit_revamped_flow) {
          aprovePayload = { qc_status: "APPROVED" };
        }
        setTimeout(() => {
          approveQcDetails(currentActiveFeId, aprovePayload).then(() => {
            history.push(`/qc-details/${currentActiveFeId}`);
          });
        }, 500);
      }
    });
  };

  const handleQcApproveClickButton = () => {
    if (editableField !== "") {
      setErrors([editStateError]);
      return;
    }
    setShowQcApproveModal(true);
  };

  const handleQcApproveCancelButton = () => {
    setShowQcApproveModal(false);
  };

  const getTabData = () => {
    return activeIndex === "Details" ? (
      saveState ? (
        <QcDriverBasicDetailsEdit
          onboardingFlow={onboardingFlow}
          editableField={editableField}
          initialState={initialState}
          setInitialState={setInitialState}
          details={qcDetails}
          verifiedOptions={verifiedOptions}
          setEditableField={setEditableField}
          setShowSingleFieldEditOptions={setShowSingleFieldEditOptions}
          showSingleFieldEditOptions={showSingleFieldEditOptions}
          handleVerifiedChange={handleVerifiedChange}
          rejectionReasons={qcRejectionReasons}
          docTypes={qcDocTypes}
          handleRejectionReasonChange={handleRejectionReasonChange}
          handleDocTypeChange={handleDocTypeChange}
          qcApproved={qcApproved}
          permission={allActions.WRITE}
        />
      ) : (
        <QcDriverBasicDetails
          details={qcDetails}
          onboardingFlow={onboardingFlow}
        />
      )
    ) : saveState ? (
      <QcDriverDocumentDetailsEdit
        onboardingFlow={onboardingFlow}
        editableField={editableField}
        initialState={initialState}
        setInitialState={setInitialState}
        details={qcDetails}
        verifiedOptions={verifiedOptions}
        setEditableField={setEditableField}
        setShowSingleFieldEditOptions={setShowSingleFieldEditOptions}
        showSingleFieldEditOptions={showSingleFieldEditOptions}
        handleVerifiedChange={handleVerifiedChange}
        rejectionReasons={qcRejectionReasons}
        docTypes={qcDocTypes}
        handleRejectionReasonChange={handleRejectionReasonChange}
        handleDocTypeChange={handleDocTypeChange}
        qcApproved={qcApproved}
        permission={allActions.WRITE}
      />
    ) : (
      <QcDriverDocumentDetails details={qcDetails} />
    );
  };

  //custom debouncing implemented
  const getDriverQcDetails = (feid) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      setQcApproved(false);
      setQcPartiallyApproved(false);
      resetState({ state: "qcDetails" });
      resetState({ state: "currentActiveFeId" });
      getQcDetails(feid).then((res) => {
        if (res) {
          window.history.replaceState(null, null, `/qc-details/${feid}`);
          setShowSingleFieldEditOptions("");
          setEditableField("");
        }
      });
    }, 500);
  };

  const handleInputChange = (e) => {
    setCurrentFeId(e);
    if (e) {
      getDriverQcDetails(e);
    }
  };

  const IsQcStatusApproved = () => {
    setQcPartiallyApproved(
      getPath(qcDetails, "qc_status", "") === "PARTIALLY_APPROVED"
    );
    setQcApproved(getPath(qcDetails, "qc_status", "") === "APPROVED");
  };

  const verifiedOptions = [
    {
      label: "Accept",
      value: true,
      disabled: qcApproved,
    },
    {
      label: "Reject",
      value: false,
      disabled: qcApproved,
    },
  ];

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  useEffect(() => {
    (qcRejectionReasons.length === 0 || qcDocTypes.length === 0) &&
      getQcAdditionalData();
  }, []);

  useEffect(() => {
    if (Feid) {
      setCurrentFeId(Feid);
      getDriverQcDetails(Feid);
    }
  }, [Feid]);

  useEffect(() => {
    if (currentActiveFeId) {
      setCurrentFeId(currentActiveFeId);
      window.history.replaceState(
        null,
        null,
        `/qc-details/${currentActiveFeId}`
      );
    }
  }, [currentActiveFeId]);

  useEffect(() => {
    const payload = {
      basic_details: qcDetails.basic_details
        ? JSON.parse(JSON.stringify(qcDetails.basic_details))
        : {},
      document_details: qcDetails.document_details
        ? JSON.parse(JSON.stringify(qcDetails.document_details))
        : {},
    };
    if (editableField == "") {
      setInitialState(payload);
    }
    setShowQcApproveModal(false);
    if (qcDetails && Object.keys(qcDetails).length > 0) {
      if (!qcApproved && shouldQcApproved(payload)) {
        setShowQcButton(true);
      } else {
        setShowQcButton(false);
      }
      IsQcStatusApproved();
    }
  }, [qcDetails]);

  return [
    <QcSection>
      <FlexContainer align="flex-start">
        <Heading>Qc Details</Heading>
        <Input
          onChange={handleInputChange}
          value={currentFeId}
          id="sushi-input"
          label="Driver FE ID"
          required
          borderColor={styles.primaryColor}
          autoFocus
        />
      </FlexContainer>
      {getPath(Object.keys(qcDetails), "length", 0) ? (
        <React.Fragment>
          <RightButtons>
            {saveState ? (
              <FlexContainer>
                {!showQcButton && (
                  <Permission requiredPerms={[allActions.WRITE]}>
                    <Button
                      data-testId="saveDriverDetail"
                      onClick={handleSaveClick}
                      className="sushi-btn mr-10"
                      disabled={qcApproved}
                    >
                      Save
                    </Button>
                  </Permission>
                )}
                {showQcButton && (
                  <Permission requiredPerms={[allActions.WRITE]}>
                    <Button
                      data-testId="qcApproveDriverDetail"
                      onClick={handleQcApproveClickButton}
                      className="sushi-btn mr-10"
                      disabled={qcApproved}
                    >
                      Qc Approve & Proceed
                    </Button>
                  </Permission>
                )}
                <Button
                  data-testId="cancelSavingQcDetail"
                  onClick={handleCancelClick}
                  className="sushi-btn"
                  appearance="outline"
                >
                  Cancel
                </Button>
              </FlexContainer>
            ) : (
              <FlexContainer justify="space-between">
                <Button
                  data-testId="verifyQcDetailsBtn"
                  className="sushi-btn mr-10"
                  appearance="outline"
                  disabled={true}
                >
                  {isValNull(qcDetails.qc_status)
                    ? "QC status: NA"
                    : qcDetails.qc_status}
                </Button>
                <Button
                  data-testId="verifyQcDetailsBtn"
                  onClick={handleVerifyClick}
                  className="sushi-btn"
                  appearance="outline"
                  disabled={isVerifyDIsabled()}
                >
                  {!isValNull(qcDetails.qc_status) &&
                  qcDetails.qc_status == "APPROVED"
                    ? "Verified"
                    : "Verify"}
                </Button>
              </FlexContainer>
            )}
          </RightButtons>
          {isVerifyDIsabled() ? (
            <AddressButtonSecondary
              id="info-button"
              address="has not yet filled all the details."
              addressPrefix="The Delivery partner "
              isNotValid
              hideChangeButton={true}
            />
          ) : (
            <div></div>
          )}
          <HorizontalTabs id="sushi-tabs" className="mb-20" alignLinks="left">
            {detailTabs.map((tab, index) => {
              return (
                <HorizontalTabs.Link
                  active={activeIndex === tab}
                  onClick={() => handleTabClick(tab)}
                  key={index}
                  className={`tab${index}${activeIndex === tab}`}
                >
                  {tab}
                </HorizontalTabs.Link>
              );
            })}
          </HorizontalTabs>
          {qcDetails.driver_lifecycle_status === "terminated" ? (
            <p className="status-approved-message">
              *Driver is terminated. You will not be able to make changes
            </p>
          ) : qcApproved ? (
            <p className="status-approved-message">
              *Qc is approved already, you will no longer be able to make
              changes
            </p>
          ) : (
            <div />
          )}
          {getTabData()}
        </React.Fragment>
      ) : (
        <BlankState message="Provide valid FE Id to see details" />
      )}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </QcSection>,
    <ConfirmationModal
      open={showQcApproveModal}
      modalTitle="Approve request"
      onCofirmCancelHandler={handleQcApproveCancelButton}
      onCofirmSuccessHandler={handleQcApprove}
      successButtonText="Yes"
      CancelButtonText="No"
    >
      Are you sure to approve the QC?
    </ConfirmationModal>,
  ];
};

const QcSection = styled.section`
  #info-button {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  #sushi-tabs {
    margin-top: ${isMobile() ? "10px" : "-10px"};
  }
  #sushi-input {
    padding-right: unset;
  }
  .row-heading,
  .row-text {
    font-size: 0.875rem !important;
    font-weight: 500;
  }
  .customDropdown {
    margin-bottom: unset;
  }
  .inbox-dropdown {
    margin-bottom: 30px;
  }
  .fields-holder {
    padding: 30px;
  }
  .section-heading {
    margin-bottom: 20px;
  }
  .status-approved-message {
    color: ${variables.primaryColor};
    font-size: 0.875rem !important;
    margin-bottom: 20px;
  }
`;

const RightButtons = styled(FlexContainer)`
  justify-content: flex-end;
`;

export const QcFieldsContainer = styled.div``;

export const DocImg = styled.img`
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid ${variables.grey200};
  object-fit: contain;
  background-color: ${variables.grey200};
  justify-content: center;
  cursor: ${({ cursor = "pointer" }) => cursor};
`;

function mapStateToProps(state) {
  const { QcDetails } = state;
  return {
    qcDetails: QcDetails.qcDetails,
    currentActiveFeId: QcDetails.currentActiveFeId,
    qcRejectionReasons: QcDetails.qcRejectionReasons,
    qcDocTypes: QcDetails.qcDocTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getQcDetails: bindActionCreators(getQcDetails, dispatch),
    getQcAdditionalData: bindActionCreators(getQcAdditionalData, dispatch),
    saveQcDetails: bindActionCreators(saveQcDetails, dispatch),
    approveQcDetails: bindActionCreators(approveQcDetails, dispatch),
    setQcDetails: bindActionCreators(setQcDetails, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QcDetails2);
